import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";

export const requestMarkExpeditionAsDelivered = async (
  orderId: string
): Promise<void> => {
  return await instance.put(
    buildUrl(ApiRoutesOrders.MarkExpeditionAsDelivered, orderId)
  );
};
